export default __webpack_public_path__ + "static/media/portfolio-89.d3f162f1.jpg";